import { Grid } from "@mui/material";
import { isMobile } from "react-device-detect";
import TabPanel from "../../../components/carousel/TabPanel";
import ConteudoQuinta from "./ConteudoQuinta";

const AgendaCarouselTabsQuinta = (props: { activeTab: any, index: number,  dateStartReference: Date, eventListTodayMaisTres: Array<any>, loadEventos: () => void, loading: boolean}) => {

    return (
        <Grid style={{ borderRadius: "6px"}}>
            <TabPanel value={props.activeTab} index={props.index}>
                <ConteudoQuinta index={props.index} activeTab={props.activeTab} dateStartReference={props?.dateStartReference} eventListTodayMaisTres={props?.eventListTodayMaisTres} loadEventos={props?.loadEventos} loading={props?.loading} />
            </TabPanel>
        </Grid>
    )
}

export default AgendaCarouselTabsQuinta;